import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IEmailTemplate } from "../model";

export default class EmailTemplateService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<IEmailTemplate>> => 
    this.GetFetch<IResponse<IEmailTemplate>>('entity/emailtemplate', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, idcliente?: number, clienteNombre?: string, nombre?: string, tipo?: string, subject?: string, activo?: boolean }) : Promise<IPaginatedResponse<IEmailTemplate>> => 
    this.GetFetch<IPaginatedResponse<IEmailTemplate>>('entity/emailtemplate/find', data);

  all = () : Promise<IResponse<IEmailTemplate[]>> => 
    this.GetFetch<IResponse<IEmailTemplate[]>>('entity/emailtemplate/all', {});

  upsert = (data:IEmailTemplate) : Promise<IResponse<IEmailTemplate>> => 
    this.PostFetch<IResponse<IEmailTemplate>>('entity/emailtemplate', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/emailtemplate', data);

  tipos = {
    all: () : Promise<IResponse<string[]>> => 
      this.GetFetch<IResponse<string[]>>('entity/emailtemplate/tipos/all', {})
  }
}
